import React, { Component, createContext } from 'react';

// Flow infers the types of a context from its default value
const defaultContextValue = {
  // eslint-disable-next-line no-unused-vars
  addSelectedDataEntryIds: (...dataEntryIds: Array<string>) => undefined,
  clearSelectedDataEntryIds: () => undefined,
  // eslint-disable-next-line no-unused-vars
  isDataEntryIdSelected: (dataEntryId: string) => false,
  // eslint-disable-next-line no-unused-vars
  removeSelectedDataEntryIds: (...dataEntryIds: Array<string>) => undefined,
  selectedDataEntryIds: [],
};

type SelectedDataEntriesContext = {
  addSelectedDataEntryIds: (...ids: string[]) => any;
  clearSelectedDataEntryIds: () => void;
  isDataEntryIdSelected: (id: string) => boolean;
  removeSelectedDataEntryIds: (...ids: string[]) => any;
  selectedDataEntryIds: string[];
};

const SelectedDataEntriesContext = createContext<SelectedDataEntriesContext>(defaultContextValue);

export const SelectedDataEntriesConsumer = SelectedDataEntriesContext.Consumer;

type SelectedDataEntriesProviderProps = {
  children?: React.ReactElement;
};

type SelectedDataEntriesProviderState = {
  selectedDataEntryIds: Set<string>;
};

export class SelectedDataEntriesProvider extends Component<
  SelectedDataEntriesProviderProps,
  SelectedDataEntriesProviderState
> {
  static defaultProps = {
    children: undefined,
  };

  constructor(props: SelectedDataEntriesProviderProps) {
    super(props);
    this.state = {
      selectedDataEntryIds: new Set(),
    };
  }

  clearEntries = () => {
    this.setState({ selectedDataEntryIds: new Set() });
  };

  hasEntry = (dataEntryId: string) => this.state.selectedDataEntryIds.has(dataEntryId);

  addEntries = (...dataEntryIds: Array<string>) => {
    this.setState(prevState => {
      const newSet = new Set(prevState.selectedDataEntryIds);
      dataEntryIds.forEach(id => newSet.add(id));
      return { selectedDataEntryIds: newSet };
    });
  };

  removeEntries = (...dataEntryIds: Array<string>) => {
    this.setState(prevState => {
      const newSet = new Set(prevState.selectedDataEntryIds);
      dataEntryIds.forEach(id => newSet.delete(id));
      return { selectedDataEntryIds: newSet };
    });
  };

  render() {
    const { children } = this.props;
    const { selectedDataEntryIds } = this.state;
    return (
      <SelectedDataEntriesContext.Provider
        value={{
          addSelectedDataEntryIds: this.addEntries,
          clearSelectedDataEntryIds: this.clearEntries,
          isDataEntryIdSelected: this.hasEntry,
          removeSelectedDataEntryIds: this.removeEntries,
          // Turn the set into an Array, and make sure it can only be mutated through methods
          selectedDataEntryIds: Array.from(selectedDataEntryIds.values()),
        }}
      >
        {children}
      </SelectedDataEntriesContext.Provider>
    );
  }
}
